import { ApiService } from 'common/services';
import { AxiosResponse } from 'axios';
import { ActionNotification } from 'common/types/common';
import { resolveApiBase } from 'common/utils/resolve-api-base';
import { GetNotificationsParams } from './action-notifications.types';

class ActionNotificationsApiService extends ApiService {
  getNotifications = (
    params: GetNotificationsParams
  ): Promise<AxiosResponse<{ notifications: ActionNotification[] }>> => {
    return this.get('/action-notifications/list', { params });
  };

  stopNotification = (notificationID: number) => {
    return this.post(`/action-notifications/${notificationID}/stop`);
  };
}

export const actionNotificationsApi = new ActionNotificationsApiService(resolveApiBase());
